import { Outlet } from 'react-router-dom'
import { ProtectedRoute } from '@/entities/protected-route'

/** Authentication boundary for booking and order-tracking operations. */
export function ProtectedAppointmentActionLayout() {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  )
}
